import WIDGETS from './widgets';

export default {
  name: 'my_files',
  spacing: 0,
	direction: 'column',
	widgets: [
		{ content: WIDGETS.GOBACKFILES, breakpoints: { xs: 12, sm: 12 }, lazy_loading: 0 },
		{ content: WIDGETS.MYFILESTICKET, breakpoints: { xs: 12, sm: 12 } },
	],
};
